import { CopyButton } from "@arcadeai/design-system/components/ui/atoms/copy-button";
import { buildGatewayUrl } from "@arcadeai/ui-kit/mcp-gateway-connect";
import { Link } from "lucide-react";
import { useEnginePublicUrl } from "../../api/get-app-config";

type UrlPreviewProps = {
  slug?: string | null;
  className?: string;
};

export function UrlPreview({ slug, className = "" }: UrlPreviewProps) {
  const enginePublicUrl = useEnginePublicUrl();
  const displaySlug = slug || "your-slug-or-id";
  const fullUrl = buildGatewayUrl(enginePublicUrl, displaySlug);
  const hasSlug = Boolean(slug);

  return (
    <div
      className={`rounded-lg border border-border/30 bg-muted/20 p-3 ${className}`}
    >
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          <div className="mb-1.5 flex items-center gap-1.5">
            <div className="flex h-5 w-5 items-center justify-center rounded bg-green-100 dark:bg-green-900/20">
              <Link className="h-3 w-3 text-green-600 dark:text-green-400" />
            </div>
            <span className="font-medium text-muted-foreground text-xs uppercase tracking-wide">
              Preview URL
            </span>
          </div>

          <div className="group flex items-center gap-2 rounded-md border border-border/50 bg-background/50 px-3 py-2.5 transition-colors hover:bg-background/80">
            <div className="min-w-0 flex-1">
              <div
                className={`break-all font-mono text-sm ${hasSlug ? "font-medium text-foreground" : "text-muted-foreground/60 italic"}`}
              >
                {fullUrl}
              </div>
            </div>

            <div className="flex h-7 w-7 items-center justify-center">
              {!!hasSlug && (
                <CopyButton
                  className="h-7 w-7 opacity-60 transition-opacity group-hover:opacity-100"
                  content={fullUrl}
                  size="sm"
                  variant="ghost"
                />
              )}
            </div>
          </div>

          <p className="mt-2 text-muted-foreground text-xs">
            {hasSlug
              ? "Your MCP server will be accessible at this URL"
              : "Enter a slug below to customize your server URL"}
          </p>
        </div>
      </div>
    </div>
  );
}
